/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_google_ad: StateInterface["ai_boost_google_ad"] = {
	_id: "",
	boost_id: "",
	property_id: "",
	ad_resource_name: "",
	ad_group_resource_name: "",
	campaign_resource_name: "",
	lead_form_resource_name: "",
	ad_name: "",
	ad_type: "",
	status: "",
	headlines: [],
	descriptions: [],
	sitelinks: [],
	callouts: [],
	created_at: "",
	updated_at: "",
	is_deleted: false,
	deleted_at: "",
	last_optimized_at: "",
	last_optimization_action: "",
	last_optimization_remarks: "",
};

export default ai_boost_google_ad;
